<ng-container *ngIf="isMobile">
    <app-mobile-forget-password>
    </app-mobile-forget-password>
</ng-container>
<ng-container *ngIf="!isMobile">
    <app-web-forget-password>
    </app-web-forget-password>
</ng-container>
